import React from 'react';
import { LoadingError } from 'components/loadingError';
import { useJobsiteLDProvider } from 'featureFlags/helpers/useJobsiteLDProvider';
import { areFeatureFlagsEnabled } from './helpers/config';

/**
 * Jobsite-scoped feature-flag provider. Nests under the app-wide (user-keyed)
 * provider and shadows it within its subtree, exposing jobsite-targeted flags
 * via `useFlags()` for both authenticated and unauthenticated users. Use around
 * any jobsite-scoped surface (e.g. self-onboarding) where the jobsite id is in
 * scope.
 */
export function JobsiteFeatureFlagsProvider({
  jobsiteId,
  children,
}: React.PropsWithChildren<{ jobsiteId: string }>): React.ReactElement {
  const LDProvider = useJobsiteLDProvider(jobsiteId);

  if (LDProvider) {
    return <LDProvider>{children}</LDProvider>;
  }

  if (jobsiteId && areFeatureFlagsEnabled()) {
    return <LoadingError loading />;
  }

  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{children}</>;
}
